export interface AccountVoucherView {
  login: string
  radiusLogin: string
  hotspotLogin: boolean
  planName?: string | null
  expiresAt?: string | null
  quotaBytes?: number | null
  quotaSeconds?: number | null
}

export interface RouterLogin {
  login: string
  password: string
  quotaBytes?: number | null
  quotaSeconds?: number | null
}

export interface ActivatedPackage {
  planName: string | null
  expiresAt: string | null
  quotaBytes: number | null
  quotaSeconds: number | null
}

export type AccountVoucherOutcome =
  | { kind: 'routerLogin'; login: RouterLogin }
  | { kind: 'activatedOnAccount'; activated: ActivatedPackage }

export function accountVoucherOutcome(view: AccountVoucherView, password: string): AccountVoucherOutcome {
  if (view.hotspotLogin) {
    return {
      kind: 'routerLogin',
      login: { login: view.radiusLogin, password, quotaBytes: view.quotaBytes, quotaSeconds: view.quotaSeconds },
    }
  }
  return {
    kind: 'activatedOnAccount',
    activated: {
      planName: view.planName ?? null,
      expiresAt: view.expiresAt ?? null,
      quotaBytes: view.quotaBytes ?? null,
      quotaSeconds: view.quotaSeconds ?? null,
    },
  }
}
